export default "__VITE_ASSET__96308e93__"